export enum DriverPage {
  additonalDriverOpend = "additonalDriverOpend",// to set driver page form with open toggel 
  additonalDriverClosed = "additonalDriverClosed",// to set driver page form with Closed toggel 
  additonalDriverList = "additonalDriverList" // to set driver page form with Closed toggel
 }
 